import axios from "axios";
import { get, post } from "../../utils/api";
import { BROADCAST_URL, NOTIFICATION } from "../../utils/url-builder";
import BaseService from "./base.service";
import socketIOClient from "socket.io-client";
import { getNotificationToken } from "../../utils/authentication-access";

export const NOTIFICATION_TYPE = {
  END_LIVE: "LIVE_CLASS_ENDED",
  START_LIVE: "LIVE_CLASS_STARTED",
};

class NotificationService extends BaseService {
  constructor() {
    super();
    this.socket = socketIOClient(
      NOTIFICATION.getEndPoint(getNotificationToken())
    );

    // // // to remove
    // this.socket.on("notification", msg => {
    //   console.log("%%%%%%");
    //   console.log({ msg });
    // });
  }

  register(types, callback) {
    this.socket.on("notification", data => {
      const { message } = data;

      if (types.indexOf(message.type) === -1) {
        return;
      }

      callback(message);
    });
  }

  read = userId =>
    new Promise(async (resolve, reject) => {
      try {
        let res = await get(NOTIFICATION.getAllNotifications(userId));
        return resolve(res.data.data);
      } catch (error) {
        reject(error);
      }
    });

  deleteAll = receiverId =>
    new Promise(async (resolve, reject) => {
      try {
        await post(NOTIFICATION.deleteAllNotification(), { receiverId });
        return resolve();
      } catch (error) {
        reject(error);
      }
    });
}

const notificationService = new NotificationService();

export default notificationService;
